import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {InBaseFrwComponent} from "../inBaseFrwComponent";
import {Router} from "@angular/router";

@Component({
  selector: 'cmp-aside',
  template: `<!-- BUTTON -->
<input id="slide-aside" #inputAside type="checkbox" role="button" />
<label for="slide-aside"class="" (click)="inputAside.click()">
  <ng-content></ng-content>
</label>
<div class="aside-bg"></div>
<!-- ASIDE -->
<div class="aside">
  <div class="aside-header p-3 clearfix">
    <h6 class="aside-title float-left">User Profile</h6>
  </div>
  <div class="aside-body p-3">
    <div class="media border-bottom pb-3 mb-3">
      <span class="avatar-media mr-2 rounded-circle">X</span>
      <div class="fa fa-"></div>
      <div class="media-body clearfix">
        <h6 class="avatar-name float-left">User name</h6>
      </div>
    </div>
    <!-- TABS SECTION -->
    <ul class="nav border-bottom mb-3">
      <li class="nav-item">
        <a class="nav-link active" href="">Profile</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="">Setting Account</a>
      </li>
    </ul>
    <!-- LIST EDIT INPUTS -->
    <!-- <form>
      <div class="form-group">
        <p class="mb-0" for="exampleInputEmail1">User Name</p>
        <input type="text" class="form-control" id="" aria-describedby="" placeholder="Add..">
      </div>
      <div class="form-group">
        <p class="mb-0" for="exampleInputEmail1">Email</p>
        <input type="email" class="form-control" id="" aria-describedby="" placeholder="Add..">
      </div>
      <div class="form-group">
        <p class="mb-0" for="exampleInputEmail1">Address</p>
        <input type="text" class="form-control" id="" aria-describedby="" placeholder="Add..">
      </div>
      <div class="form-group">
        <p class="mb-0" for="">Example select</p>
        <select class="form-control" id="">
          <option>Country 1</option>
          <option>Country 2</option>
          <option>Country 3</option>
          <option>Country 4</option>
          <option>Country 5</option>
        </select>
      </div>
      <div class="form-group">
        <p class="mb-0" for="exampleInputEmail1">Telephone</p>
        <input type="text" class="form-control" id="" aria-describedby="" placeholder="Add..">
      </div>
      <div class="form-group">
        <p class="mb-0" for="exampleInputEmail1">Cellphone</p>
        <input type="text" class="form-control" id="" aria-describedby="" placeholder="Add..">
      </div>
      <div class="form-group">
        <p class="mb-0" for="exampleInputEmail1">Email address</p>
        <input type="text" class="form-control" id="" aria-describedby="" placeholder="Add..">
      </div>
      <button class="btn btn-outline-primary btn-sm float-right">Submit</button>
    </form> -->
    <!-- LIST PROFILE -->
    <ul class="list-group list-group-flush mb-4">
      <li class="list-group-item d-flex justify-content-between align-items-center px-0">
        <span>
          <i class="icon-list fa fa-user-o bg-primary p-2 text-white float-left"></i>
          <p class="ml-2 mt-1 mb-0 float-left">NAME:</p>
        </span>
        <span class="text-secondary font-weight-light">User Name</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center px-0">
        <span>
          <i class="icon-list fa fa-envelope-o bg-primary p-2 text-white float-left"></i>
          <p class="ml-2 mt-1 mb-0 float-left">EMAIL:</p>
        </span>
        <span class="text-secondary font-weight-light">Username@mail.com</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center px-0">
        <span>
          <i class="icon-list fa fa-home bg-primary p-2 text-white float-left"></i>
          <p class="ml-2 mt-1 mb-0 float-left">ADDRESS:</p>
        </span>
        <span class="text-secondary font-weight-light">c/address 12, 3Âº 2Âª</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center px-0">
        <span>
          <i class="icon-list fa fa-globe bg-primary p-2 text-white float-left"></i>
          <p class="ml-2 mt-1 mb-0 float-left">COUNTRY:</p>
        </span>
        <span class="text-secondary font-weight-light">Country</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center px-0">
        <span>
          <i class="icon-list fa fa-phone bg-primary p-2 text-white float-left"></i>
          <p class="ml-2 mt-1 mb-0 float-left">TELEPHONE:</p>
        </span>
        <span class="text-secondary font-weight-light">98765434</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center px-0">
        <span>
          <i class="icon-list fa fa-phone bg-primary p-2 text-white float-left"></i>
          <p class="ml-2 mt-1 mb-0 float-left">CELLPHONE:</p>
        </span>
        <span class="text-secondary font-weight-light">234567814</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center px-0">
        <span>
          <i class="icon-list fa fa-laptop bg-primary p-2 text-white float-left"></i>
          <p class="ml-2 mt-1 mb-0 float-left">JOB:</p>
        </span>
        <span class="text-secondary font-weight-light">User Job</span>
      </li>
    </ul>
    <!-- BUTTON EDIT -->
    <!-- <button class="btn btn-outline-primary btn-sm float-right">Edit</button> -->
    <!-- SETTING ACCOUNT -->
    <div class="card mb-1">
      <div class="card-header clearfix">
        <p class="mb-0 text-primary float-left">Password Update form</p>
        <i class="fa fa-angle-up text-primary float-right"></i>
      </div>
      <div class="card-body">
        <form>
          <div class="form-group">
            <p class="mb-0" for="">Current Password</p>
            <input type="password" class="form-control" id="" aria-describedby="" placeholder="add...">
          </div>
          <div class="form-group">
            <p class="mb-0" for="">New Password</p>
            <input type="password" class="form-control" id="" aria-describedby="" placeholder="add...">
          </div>
          <div class="form-group">
            <p class="mb-0" for="">New Password confirmation</p>
            <input type="password" class="form-control" id="" aria-describedby="" placeholder="add...">
          </div>
        </form>
      </div>
    </div>
  </div>
  
  <div class="aside-footer p-3 clearfix">
    <cmp-button [outline]="true">close</cmp-button>
  </div>
</div>
`,
  styles: [`label{z-index:1040;position:fixed;top:12px;right:20px}input[type=checkbox]{display:none}input:checked~.aside-bg{right:0;background-color:rgba(0,0,0,.6);transition:right .1s}input:checked~.aside{right:0;transition:right .5s}.aside-bg{position:fixed;top:55px;width:100%;right:-10000px;height:100%;background-color:rgba(0,0,0,.6);z-index:1205;transition:right .3s}.aside{position:fixed;top:55px;right:-520px;width:500px;height:100%;background-color:#fff;z-index:1210;border-left:1px solid #ccc;transition:right .5s}.aside-header{background-color:#f8f9fa;border-bottom:1px solid #dee2e6}.aside-header .aside-title{margin-bottom:0}.aside-body{height:100%;overflow:auto}.aside-body .media .avatar-media{width:40px;height:40px;text-align:center;padding-top:8px;background-color:#2d6daa;color:#fff}.aside-body .media .avatar-name{margin-top:10px}.aside-body .icon-list{width:30px;height:30px;text-align:center}.aside-footer{position:fixed;width:500px;bottom:0;background-color:#f8f9fa;border-top:1px solid #dee2e6}.nav .nav-item .nav-link.active{border-bottom:2px solid #2d6daa}`]
})
export class AsideComponent extends InBaseFrwComponent implements OnInit {
  isCollapsed = [];

  @Input() data = [];
  @Output() optionSelected = new EventEmitter();
  @Output() onNavigate = new EventEmitter();

  constructor(protected router: Router) {
    super();
  }

  ngOnInit() {
  }
}
